import Column from "@/atoms-react/column/Column.react";
import { DynamicBlobAnimation } from "@/components/animations/dynamic-blob/index.react";
import { AuthApiClient } from "@/features/auth/api-client/api-client";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import useCaptchaVerify from "@/features/utils/hooks/use_captcha_verify";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FlowHeader } from "../../../flow-header.react";
export const RecoverPassword = () => {
  const { getLanguage } = usei18n();
  const { substep } = useParams();
  const { t } = useTranslation(["pass"]);
  const { handleReCaptchaVerify } = useCaptchaVerify();

  // Decode email from url encoded
  const email = decodeURIComponent(substep || "");
  useEffect(() => {
    const handleRecaptcha = async () => {
      if (email) {
        const captchaToken = await handleReCaptchaVerify();
        if (captchaToken) {
          await AuthApiClient.forgetPasswordLink(email, captchaToken, getLanguage());
        } else {
          toast.error("An error occurred");
        }
      }
    };
    handleRecaptcha();
  }, [email]);

  return (
    <>
      <Column>
        <div className="mb-12 flex grow flex-col">
          <FlowHeader
            title={t("flow.id_control.label.recover_title")}
            description={t("flow.id_control.label.recover_description", { email })}
            goHomePage={true}
          />
          <DynamicBlobAnimation src="/images/olkypass/recover-password-bg.png" />
        </div>
      </Column>
    </>
  );
};
